import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { ThemingSubTabContainer } from "@containers/common/theming-sub-tab-container/theming-sub-tab-container";
import { ScoresValidationErrors } from "@idw-types/common/validation/verification-service-details-validation-errors";
import { FormattedRpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import { ScoreReferenceData } from "@idw-types/data/rp-service-configuration/scores/score-reference-data";
import { AssertionScoreTabContainer } from "./assertion-scores-tab-container/assertion-score-tab-container";
import { TrustScoreTabContainer } from "./trust-score-tab-container/trust-score-tab-container";
import { ApAssertionStatusMap } from "@idw-types/data/ap-assertion-status-map/ap-assertion-status-map";

type VerificationServiceDetailsScoresTabProps = {
    isDisabled: boolean;
    validationErrors: ScoresValidationErrors;
    assertionStatusMaps: Array<ApAssertionStatusMap>;
    assertionScoreServiceOfferingIDs: Array<string>;
    trustScoreServiceOfferingIDs: Array<string>;
    rpServiceConfigurationState: FormattedRpServiceConfiguration;
    scoreReferenceData: ScoreReferenceData;
    scoreServiceOfferingIDs: Array<string>;
    setRpServiceConfigurationState: (
        state: FormattedRpServiceConfiguration
    ) => void;
};

export const VerificationServiceDetailsScoresTab = (
    props: VerificationServiceDetailsScoresTabProps
) => {
    const {
        isDisabled,
        validationErrors,
        rpServiceConfigurationState,
        assertionStatusMaps,
        assertionScoreServiceOfferingIDs,
        trustScoreServiceOfferingIDs,
        scoreServiceOfferingIDs,
        setRpServiceConfigurationState,
        scoreReferenceData
    } = props;

    return (
        <ThemingSubTabContainer>
            <Tabs id="scores" unmountOnExit={true}>
                <Tab
                    eventKey={"assertionScore"}
                    title={validationErrors.assertionScore.tabTitle}>
                    <AssertionScoreTabContainer
                        scoreReferenceData={scoreReferenceData}
                        assertionScoreServiceOfferingIDs={assertionScoreServiceOfferingIDs}
                        scoreServiceOfferingIDs={scoreServiceOfferingIDs}
                        isDisabled={isDisabled}
                        validationErrors={validationErrors.assertionScore}
                        assertionStatusMaps={assertionStatusMaps}
                        rpServiceConfigurationState={rpServiceConfigurationState}
                        setRpServiceConfigurationState={setRpServiceConfigurationState}
                    />
                </Tab>

                <Tab
                    eventKey={"trustScore"}
                    title={validationErrors.trustScore.tabTitle}>
                    <TrustScoreTabContainer
                        scoreReferenceData={scoreReferenceData}
                        trustScoreServiceOfferingIDs={trustScoreServiceOfferingIDs}
                        isDisabled={isDisabled}
                        validationErrors={validationErrors.trustScore}
                        assertionStatusMaps={assertionStatusMaps}
                        scoreServiceOfferingIDs={scoreServiceOfferingIDs}
                        rpServiceConfigurationState={rpServiceConfigurationState}
                        setRpServiceConfigurationState={setRpServiceConfigurationState}
                    />
                </Tab>
            </Tabs>
        </ThemingSubTabContainer>
    );
};
